import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TextContent } from "../../../../../shared/TextContent/TextContent";
import { EHCMappingData } from "../EHCMappingData";
import DynamicTable from "../../../../../shared/DynamicTable/DynamicTable";
import PointerContent from "../../../../../shared/PointerContent/PointerContent";
import InternalLinkData from "../../../../../shared/DynamicTable/InternalLinkData";
import ExternalLinkData from "../../../../../shared/DynamicTable/ExternalLinkData";
import { supportedResourceDetailsDataScript } from "../../../SupportedCapabilities/SupportedResources/SupportedResourcesData";
import SideBarData from "../../../../Documentation/SideBar/SideBarData";
import CustomBreadCrumbs from "../../../../../shared/BreadCrumbs/CustomBreadCrumbs";

function ImportMappingDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlValue = queryParams.get("value");
  const [EHCMappingDetailsData] = supportedResourceDetailsDataScript.filter(
    (data) => data.name.toLowerCase() === urlValue
  );
  const [valueNotFound, setValueNotFound] = useState(false);

  useEffect(() => {
    if (
      !urlValue ||
      !EHCMappingDetailsData[urlValue] ||
      !EHCMappingDetailsData[urlValue].name
    ) {
      setValueNotFound(false);
    }
  }, []);

  if (valueNotFound) {
    return "Value not found";
  }

  return (
    <section
      className="page-group"
      id="elevance-health-concepts-mapping-details"
    >
      <CustomBreadCrumbs
        breadcrumbs={[`${SideBarData[4].subgroups[0]}`, `${EHCMappingDetailsData.name}`]}
      />
      <TextContent
        EHCMappingDetailsData
        header={` Resource ${
          EHCMappingDetailsData.name[0].toUpperCase() +
          EHCMappingDetailsData.name.slice(1)
        }`}
        description={EHCMappingDetailsData.description}
      />
      <div className="supported-interactions">
        <h4>Supported Interactions</h4>
        <ul>
          {EHCMappingDetailsData.supportedInteractions.map((interaction) => (
            <li>
              <ExternalLinkData
                value={interaction}
                href={`https://hl7.org/fhir/R4/http.html#${interaction}`}
              />
            </li>
          ))}
        </ul>
      </div>

      <div className="search-parameters">
        <DynamicTable
          title="Search Parameters"
          columns={[
            "Name",
            "Type",
            "Modifiers/Prefixes",
            "Multiple Values",
            "Can be chained",
            "Description",
          ]}
          data={EHCMappingDetailsData.searchParameters}
        />
      </div>
      <div className="sorts">
        <h4>Sorts</h4>
        <ul>
          {EHCMappingDetailsData.sorts.map((sortItem) => (
            <li>{sortItem}</li>
          ))}
        </ul>
        {EHCMappingDetailsData.sorts.length > 1 && (
          <p className="support-desc">Supports multiple sorts</p>
        )}
      </div>
      <div className="includes">
        <h4>Includes</h4>
        <ul>
          {EHCMappingDetailsData.includeItems.map((includeItem) => (
            <li>{includeItem}</li>
          ))}
        </ul>
      </div>
      <div className="operations">
        <h4>Operations</h4>
        <ul>
          {EHCMappingDetailsData.operations.map((item) => {
            if (item.linkValue === "validate") {
              return (
                <li>
                  <ExternalLinkData value={item.linkValue} href={item.href} />
                  {` ${item.description}`}
                </li>
              );
            } else {
              return (
                <li>
                  <InternalLinkData
                    value={item.linkValue}
                    documentationSection={"supported-system-operations"}
                  />
                  {` ${item.description}`}
                </li>
              );
            }
          })}
        </ul>
      </div>
    </section>
  );
}

export default ImportMappingDetails;
